import $ from "jquery";
let Dispatcher;
let ProcessButton;
let React;
let StripeStore;
let UserStore;
let Payment;

Dispatcher = require("../dispatcher/dispatcher").default;

ProcessButton = require("../components/processbutton").default;

React = require("react");

StripeStore = require("../stores/stripestore").default;

UserStore = require("../stores/userstore").default;

Payment = require("payment");

class Billing_Form extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showBilling: false,
            buttonState: "initial",
            selectedPlan: void 0,
            showAccountPrice: false,
            isALaCarte: true,
            showLabel: void 0,
            card: void 0
        };
    }

    onInteraction(event) {
        let $input;
        event.preventDefault();
        $input = $(event.target);
        if ($input.hasClass("error")) {
            StripeStore._errors = {};
            return this.setState({
                showLabel: void 0,
                errors: void 0
            });
        } else {
            if (this.value !== "") {
                return this.setState({
                    showLabel: "show"
                });
            } else {
                return this.setState({
                    showLabel: void 0
                });
            }
        }
    }

    build() {
        let card;
        let err;
        let fld;
        let premium;
        let ref;
        premium = (_this => (me, plan) => {
            let chargeInterval;
            let costInterval;
            let price;
            switch (plan) {
                case "pro-monthly":
                    costInterval = gettext("Total");
                    chargeInterval = gettext("monthly");
                    price =
                        StripeStore.plans.pro.monthly.price +
                        "/" +
                        gettext("month");
                    break;
                case "pro-yearly":
                    costInterval = gettext("Total");
                    chargeInterval = gettext("yearly");
                    price =
                        StripeStore.plans.pro.yearly.price +
                        "/" +
                        gettext("year");
                    break;
                case "team-999":
                    costInterval = gettext("Total");
                    chargeInterval = gettext("monthly");
                    price = "9.99 / " + gettext("User / Month");
                    break;
                case "team-9990":
                    costInterval = gettext("Total");
                    chargeInterval = gettext("yearly");
                    price = "99 / " + gettext("User / Year");
            }
            _this.save_payment = null;
            this.sub_total_copy = (
                <li className="footer">
                    <div className="price-status">
                        {costInterval} <span id="dash" className="black" /> $
                        <span className="cost-total">{price}</span>
                    </div>
                </li>
            );
            return (this.upgrade_disclaimer = (
                <p className="upgrade_disclaimer">
                    {gettext("You will be charged now and ")}
                    {chargeInterval}
                    {gettext(
                        " at this time when your account automatically renews. Cancel automatic renewal at any time."
                    )}
                </p>
            ));
        })(this);
        this.fields = {
            card_name: {
                className: "",
                labelClassName: this.state.showLabel,
                labelText: gettext("Name on Card")
            },
            card_number: {
                className: "",
                labelClassName: this.state.showLabel,
                labelText: gettext("Credit Card Number")
            },
            card_expiration: {
                className: "",
                labelClassName: this.state.showLabel,
                labelText: gettext("Card Expiration")
            },
            card_cvc: {
                className: "",
                labelClassName: this.state.showLabel,
                labelText: "CVC"
            },
            general: {
                className: "",
                labelClassName: ""
            },
            disabled: false
        };
        ref = this.state.errors;
        for (fld in ref) {
            err = ref[fld];
            if(this.fields[fld]) {
                this.fields[fld].className += " error on";
                this.fields[fld].labelClassName += " error on";
                this.fields[fld].labelText = err;
            } else {
                console.error("unknown error", fld, err);
            }
        }
        if (this.state.card && this.state.card.ok === true) {
            card = UserStore._data.card;
            this.fields.card_name.inputValue = card.card_name;
            this.fields.card_number.inputValue = card.card_number;
            this.fields.card_expiration.inputValue = card.card_expiration;
            this.fields.card_cvc.inputValue = card.card_cvc;
            this.fields.disabled = true;
        } else {
            this.fields.card_name.inputValue = void 0;
            this.fields.card_number.inputValue = void 0;
            this.fields.card_expiration.inputValue = void 0;
            this.fields.card_cvc.inputValue = void 0;
            this.fields.disabled = false;
        }
        if (this.source === "for-mac") {
            this.features = (
                <ul className="features">
                    <li className="emphasis">
                        {gettext("Save time with the")}{" "}
                        <span className="plan-pro">Mac App</span>
                    </li>
                    <li>
                        {gettext("Unlimited royalty free icons")}
                    </li>
                    <li>
                        {gettext("No need to credit the creator")}
                    </li>
                    <li>
                        {"Download icons in any color"}
                    </li>
                    <li>
                        {gettext("Access to website as a Pro member")}
                    </li>
                    <li>
                        Access to{" "}
                        <a
                            href="https://itunes.apple.com/us/app/nounji/id1142880288?ls=1&amp;mt=8&amp;app=messages"
                            target="_blank"
                        >
                            <span className="plan-pro">Nounji</span>
                        </a>{" "}
                        iMessages App
                    </li>
                </ul>
            );
        } else {
            this.features = (
                <div>
                    <ul className="features">
                        <li className="emphasis">
                            gettext('Unlimited royalty free icons')
                        </li>
                        <li>
                            {gettext("Save time with faster downloads")}
                        </li>
                        <li>
                            {gettext("No need to credit the creator")}
                        </li>
                        <li>
                            {"Download icons in any color"}
                        </li>
                        <li>
                            {gettext("Drag and drop with the")}{" "}
                            <a href="/for-mac/">
                                <span className="plan-pro">Mac App</span>
                            </a>
                        </li>
                        <li>
                            Access to{" "}
                            <a
                                href="https://itunes.apple.com/us/app/nounji/id1142880288?ls=1&amp;mt=8&amp;app=messages"
                                target="_blank"
                            >
                                <span className="plan-pro">Nounji</span>
                            </a>{" "}
                            iMessages App
                        </li>
                    </ul>

                    <p>
                        <a href="/accounts/create-team/">
                            {gettext("Collaborate with a")} NounTeam
                        </a>
                    </p>
                </div>
            );
        }
        if (this.state.showBilling) {
            this.toggle_optional_billing = null;
            this.optional_billing = (
                <section className="optional-billing">
                    <div className="">
                        <ul className="form-fields">
                            <li>
                                <textarea
                                    id="receipt-info"
                                    name="receipt_info"
                                    className="optional"
                                    placeholder="This information shows on your invoices, some people need this for tax purposes. (VAT, Address, Job Number, Etc)."
                                    onFocus={this.onInteraction.bind(this)}
                                    onKeyUp={this.onInteraction.bind(this)}
                                    onBlur={this.onInteraction.bind(this)}
                                />
                                <label
                                    className={this.state.showLabel}
                                    htmlFor="company_name"
                                >
                                    {gettext(
                                        "Optional Billing Information"
                                    )}{" "}
                                    <em>( {gettext("optional")} )</em>
                                </label>
                                <em>
                                    ( {gettext("optional")} )
                                </em>
                            </li>
                        </ul>
                    </div>
                </section>
            );
        } else {
            this.optional_billing = null;
            if (this.state.card === void 0) {
                this.toggle_optional_billing = (
                    <li onClick={this.onShowBilling.bind(this)}>
                        <a href="#" className="show-optional-billing">
                            <span className="ui_plus-circle-filled icon-link" />
                            <span className="text-link">
                                {gettext("Add optional billing information")}
                            </span>
                        </a>
                    </li>
                );
            } else {
                this.toggle_optional_billing = null;
            }
        }
        if (this.state.card && this.state.card.ok === true) {
            this.yearlyInput = (
                <input
                    id="pro-yearly"
                    className="input-radio pro-yearly"
                    type="radio"
                    name="plan"
                    value="pro-yearly"
                />
            );
            this.aLaCarteInput = (
                <input
                    id="a-la-carte"
                    className="input-radio a-la-carte"
                    type="radio"
                    name="plan"
                    value="a-la-carte"
                    defaultChecked
                />
            );
        } else {
            this.yearlyInput = (
                <input
                    id="pro-yearly"
                    className="input-radio pro-yearly"
                    type="radio"
                    name="plan"
                    value="pro-yearly"
                    defaultChecked
                />
            );
            this.aLaCarteInput = (
                <input
                    id="a-la-carte"
                    className="input-radio a-la-carte"
                    type="radio"
                    name="plan"
                    value="a-la-carte"
                />
            );
        }
        this.plan_selection = (
            <ol>
                <h2 className="subscription-header">
                    {gettext("Unlimited downloads of nearly a million icons")}
                </h2>
                <div id="plan-selection">
                    <li className="half plan">
                        <input
                            id="pro-monthly"
                            className="input-radio pro-monthly"
                            type="radio"
                            name="plan"
                            value="pro-monthly"
                        />
                        <label
                            htmlFor="pro-monthly"
                            onClick={this.onPlanChange.bind(this)}
                        >
                            ${StripeStore.plans.pro.monthly.price}/{gettext("mo")}
                        </label>
                    </li>
                    <li className="half plan">
                        {this.yearlyInput}
                        <label
                            htmlFor="pro-yearly"
                            onClick={this.onPlanChange.bind(this)}
                        >
                            ${StripeStore.plans.pro.yearly.price}/{gettext("yr")}
                        </label>
                    </li>
                </div>
                <div className="subscription-description">
                    NounPro subscriptions include access to unlimited
                    royalty-free icons, faster downloads, free Mac App, and free
                    Nounji sticker app for iMessage.
                </div>
                <div id="a-la-carte-selection">
                    <h2 className="a-la-carte-header">
                        {gettext("Pay per icon")}
                    </h2>
                    {this.aLaCarteInput}
                    <label
                        htmlFor="a-la-carte"
                        className="a-la-carte"
                        onClick={this.onPlanChange.bind(this)}
                    >
                        $1.99 {gettext("royalty-free license")}
                    </label>
                </div>
            </ol>
        );
        switch (this.state.plan) {
            case "a-la-carte":
                if (this.state.card && this.state.card.ok === true) {
                    this.save_payment = (
                        <li className="save-payment-option">
                            <div id="save-payment">
                                <a
                                    href="#"
                                    onClick={this.onNewCC.bind(this)}
                                    title="Use New Card"
                                >
                                    <span className="ui_credit-card icon-link" />
                                    <span className="text-link">
                                        Use New Card
                                    </span>
                                </a>
                            </div>
                        </li>
                    );
                } else {
                    this.save_payment = (
                        <li className="save-payment-option">
                            <div id="save-payment">
                                <input
                                    id="id_save_card"
                                    name="save_card"
                                    type="checkbox"
                                    defaultChecked
                                />
                                <label
                                    htmlFor="id_save_card"
                                    className="checkbox-fillin"
                                >
                                    <i className="ui_checkbox" />
                                </label>
                                <label htmlFor="id_save_card">
                                    {gettext(
                                        "Use this card for future purchases?"
                                    )}
                                </label>
                            </div>
                        </li>
                    );
                }
                this.sub_total_copy = (
                    <li className="footer">
                        <div className="price-status">
                            {gettext("Total")}{" "}
                            <span id="dash" className="black" /> $
                            <span className="cost-total">1.99</span>
                        </div>
                    </li>
                );
                this.submit_btn = (
                    <ProcessButton
                        callback={this.onSubmit.bind(this)}
                        buttonState={this.state.buttonState}
                        resetState={this.onStripeConfirm.bind(this)}
                        iconButton={true}
                        buttonText="Charge and Download"
                        iconClass="ui_download"
                        extraClass="full-width"
                        color="blue"
                    />
                );
                return (this.upgrade_disclaimer = void 0);
            case "team":
                premium(this, this.state.planType);
                if (this.state.showAccountPrice) {
                    this.account_price = (
                        <div
                            id="account-price"
                            className="col-lg-6 col-md-6 col-xs-12 account-price"
                        >
                            <i className="ui_team-accounts plan-team" />
                            <h1>NounTeam</h1>
                            <div className="price">
                                <span className="plan-team">$9.99</span> / User
                                / Month
                                <br />
                                <small>or $99 / User / Year</small>
                            </div>

                            <ul className="features">
                                <li className="emphasis">
                                    {gettext("Collaboration with your team")}
                                </li>
                                <li>
                                    {gettext("Unlimited icon downloads")}
                                </li>
                                <li>
                                    {gettext("Consolidated billing")}
                                </li>
                                <li>
                                    {"Download icons in any color"}
                                </li>
                                <li>
                                    {gettext("Save time with the")}{" "}
                                    <a href="/for-mac/">
                                        <span className="plan-pro">
                                            Mac App
                                        </span>
                                    </a>
                                </li>
                            </ul>
                            <div className="enterprise-contact">
                                <span className="call-to-action">
                                    {gettext("Contact us for Enterprise")}
                                </span>
                                <span className="help-container">
                                    <a href="#" className="help-tip ui_help">
                                        <span className="visuallyhidden">
                                            ?
                                        </span>
                                    </a>
                                    <div className="help-box at-top">
                                        <p>
                                            {gettext(
                                                "If you have 25 or more members on your team, sign up for an Enterprise account to receive a discounted member rate."
                                            )}
                                        </p>
                                    </div>
                                </span>
                            </div>
                        </div>
                    );
                }
                this.plan_selection = (
                    <div>
                        <ol>
                            <h2 className="form-header">
                                {gettext("Choose Subscription")}
                            </h2>
                            <div className="seat-row">
                                <li>
                                    <div className="col-lg-3 col-md-3 col-xs-12">
                                        <input
                                            id="seats"
                                            type="text"
                                            className="seats"
                                            name="seats"
                                            placeholder="1"
                                            maxLength="3"
                                            min="1"
                                            value="1"
                                            required
                                        />
                                    </div>
                                    <div className="col-lg-9 col-md-9 col-xs-12">
                                        <label htmlFor="seats">
                                            {gettext(
                                                "How many members on your team?"
                                            )}
                                        </label>
                                    </div>
                                    <label htmlFor="seats" />
                                </li>
                            </div>
                            <div id="plan-selection">
                                <li className="half plan">
                                    <input
                                        id="team-monthly"
                                        className="input-radio plan-monthly"
                                        type="radio"
                                        name="plan"
                                        value="team-999"
                                        defaultChecked
                                    />
                                    <label
                                        htmlFor="team-monthly"
                                        onClick={this.onPlanChange.bind(this)}
                                    >
                                        {" "}$9.99 {gettext("Monthly")}
                                    </label>
                                </li>
                                <li className="half plan">
                                    <input
                                        id="team-yearly"
                                        className="input-radio plan-yearly"
                                        type="radio"
                                        name="plan"
                                        value="team-9990"
                                    />
                                    <label
                                        htmlFor="team-yearly"
                                        onClick={this.onPlanChange.bind(this)}
                                    >
                                        $99.90 {gettext("Yearly")}
                                    </label>
                                </li>
                            </div>
                        </ol>
                    </div>
                );
                this.upgrade_disclaimer = void 0;
                return (this.submit_btn = (
                    <ProcessButton
                        callback={this.onSubmit.bind(this)}
                        buttonState={this.state.buttonState}
                        buttonText="Finish like a boss"
                        resetState={this.onStripeConfirm.bind(this)}
                        iconClass="ui_download"
                        color="blue"
                    />
                ));
            case "pro":
                premium(this, this.state.planType);
                if (this.state.showAccountPrice) {
                    this.account_price = (
                        <div
                            id="account-price"
                            className="col-lg-6 col-md-6 col-xs-12 account-price"
                        >
                            <i className="ui_pro-accounts plan-pro" />
                            <h1>NounPro</h1>
                            <div className="price">
                                <span className="plan-pro pro-monthly-cost">
                                    $9.99
                                </span>{" "}
                                / Month
                                <br />
                                <small>
                                    or{" "}
                                    <span className="pro-yearly-cost">
                                        $99
                                    </span>{" "}
                                    / Year
                                </small>
                            </div>

                            {this.features}
                        </div>
                    );
                }
                if (this.state.isALaCarte) {
                    if (this.state.card && this.state.card.ok === true) {
                        this.save_payment = (
                            <li className="save-payment-option">
                                <div id="save-payment">
                                    <a
                                        href="#"
                                        onClick={this.onNewCC.bind(this)}
                                        title="Use New Card"
                                    >
                                        <span className="ui_credit-card icon-link" />
                                        <span className="text-link">
                                            Use New Card
                                        </span>
                                    </a>
                                </div>
                            </li>
                        );
                    } else {
                        this.save_payment = null;
                    }
                }
                if (this.state.aLaCarte === false) {
                    this.plan_selection = (
                        <div>
                            <h2 className="form-header">
                                {gettext("Choose Subscription")}
                            </h2>
                            <ol>
                                <div id="plan-selection">
                                    <li className="half plan">
                                        <input
                                            id="pro-monthly"
                                            className="input-radio plan-monthly"
                                            type="radio"
                                            name="plan"
                                            value="pro-monthly"
                                            defaultChecked
                                        />
                                        <label
                                            htmlFor="pro-monthly"
                                            onClick={this.onPlanChange.bind(
                                                this
                                            )}
                                        >
                                            $9.99 {gettext("Monthly")}
                                        </label>
                                    </li>
                                    <li className="half plan">
                                        <input
                                            id="pro-yearly"
                                            className="input-radio plan-yearly"
                                            type="radio"
                                            name="plan"
                                            value="pro-yearly"
                                        />
                                        <label
                                            htmlFor="pro-yearly"
                                            onClick={this.onPlanChange.bind(
                                                this
                                            )}
                                        >
                                            $99.90 {gettext("Yearly")}
                                        </label>
                                    </li>
                                </div>
                                <div>
                                    <li className="col-lg-12 col-md-12 col-xs-12 coupon-field hidden">
                                        <input
                                            id="coupon"
                                            name="coupon"
                                            className="optional"
                                            type="text"
                                            placeholder="{gettext('Promotional Code')}"
                                        />
                                        <label htmlFor="coupon">
                                            Promotional code <em>(optional)</em>
                                        </label>
                                        <a
                                            href="#"
                                            className="button apply-coupon"
                                        >
                                            Apply
                                        </a>
                                    </li>
                                    <li className="coupon-value">
                                        <a href="#" className="icon-link">
                                            <span className="ui_discount" />
                                        </a>
                                        <a
                                            href="#"
                                            className="icon-link text-link coupon-name"
                                        >
                                            {gettext(
                                                "Apply a promotional code"
                                            )}
                                        </a>
                                    </li>
                                </div>
                            </ol>
                        </div>
                    );
                }
                return (this.submit_btn = (
                    <ProcessButton
                        callback={this.onSubmit.bind(this)}
                        buttonState={this.state.buttonState}
                        resetState={this.onStripeConfirm.bind(this)}
                        buttonText="Upgrade like a Pro"
                        iconClass="ui_download"
                        extraClass="full-width"
                        color="blue"
                    />
                ));
        }
    }

    onStripeConfirm() {
        return Dispatcher.dispatch({
            actionType: "confirmCharge"
        });
    }

    onBillingChange() {
        let buttonState;
        let errors;
        errors = StripeStore._errors;
        buttonState = StripeStore.getCurrentStatus();
        return this.setState({
            buttonState,
            errors
        });
    }

    onPlanChange(event) {
        let $target;
        let planValue;
        $target = $(event.currentTarget).prevAll("input");
        planValue = $target.prop("value");
        switch (planValue) {
            case "a-la-carte":
                return this.setState({
                    plan: "a-la-carte",
                    planType: "a-la-carte"
                });
            case "pro-monthly":
                return this.setState({
                    plan: "pro",
                    planType: "pro-monthly"
                });
            case "pro-yearly":
                return this.setState({
                    plan: "pro",
                    planType: "pro-yearly"
                });
            case "team-999":
                return this.setState({
                    plan: "team",
                    planType: "team-999"
                });
            case "team-9990":
                return this.setState({
                    plan: "team",
                    planType: "team-9990"
                });
        }
    }

    onShowBilling(event) {
        event.preventDefault();
        return this.setState({
            showBilling: true
        });
    }

    onHideBilling(event) {
        event.preventDefault();
        return this.setState({
            showBilling: false
        });
    }

    onNewCC(event) {
        event.preventDefault();
        return this.setState({
            card: void 0
        });
    }

    componentWillMount() {
        this.card = UserStore._data.card;
        return this.setState({
            card: UserStore._data.card
        });
    }

    componentWillUnmount() {
        return StripeStore.removeListener(
            "change",
            this.onBillingChange.bind(this)
        );
    }

    componentDidMount() {
        StripeStore.addListener("change", this.onBillingChange.bind(this));
        this.sub_total_copy = (
            <li className="footer">
                <div className="price-status">
                    {gettext("Total billed today")}{" "}
                    <span id="dash" className="black" /> $
                    <span className="cost-total" />
                </div>

                <p className="when-you-are-billed">
                    {gettext("You will be charged now and")}{" "}
                    <span className="month-year-interval">monthly</span>{" "}
                    {gettext(
                        "at this time when your account automatically renews. Cancel automatic renewal at any time."
                    )}
                </p>

                <p className="when-you-are-billed-discount hidden">
                    <span className="discount-duration" />
                    {gettext("You will be charged")}{" "}
                    <span className="pro-full-cost">$9.99</span>{" "}
                    <span className="month-year-interval">monthly</span>{" "}
                    {gettext(
                        "after your discount period ends until you cancel your subscription."
                    )}
                </p>
            </li>
        );
        if (UserStore.get("user").has_pro_account) {
            this.setState({
                plan: "pro"
            });
        }
        if (UserStore.get("user").has_team_account) {
            this.setState({
                plan: "team"
            });
        }
        if (!UserStore.hasPremiumMarketAccess()) {
            if (this.state.card && this.state.card.ok === true) {
                this.setState({
                    plan: "a-la-carte",
                    planType: "a-la-carte"
                });
            } else {
                this.setState({
                    plan: "pro",
                    planType: "pro-yearly"
                });
            }
        }
        return Payment.formatCardNumber($("#card_number"));
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.card && this.state.card === void 0) {
            return $("#card_name").focus();
        }
    }

    onSubmit(event) {
        let exp;
        event.preventDefault();
        this.form = $(event.currentTarget).parents("form");
        this.data = this.form.serializeObject();
        if (this.data.yearly_pro !== void 0) {
            this.data.plan = this.data.yearly_pro;
            delete this.data.yearly_pro;
        }
        exp = this.data.card_expiration;
        if (exp !== void 0) {
            if (exp.search("/") === -1) {
                this.data.card_exp_month = exp.slice(0, 2);
                this.data.card_exp_year = exp.slice(2, 4);
            } else {
                this.data.card_exp_month = exp.split("/")[0];
                this.data.card_exp_year = exp.split("/")[1];
            }
            this.data.card_number = this.form.find("#card_number").val();
            this.data.card_cvc = this.form.find("#card_cvc").val();
        }
        this.data.icon = this.icon;
        this.setState({
            errors: void 0
        });
        return Dispatcher.dispatch({
            actionType: "startBillingSubmit",
            data: this.data,
            card: this.card
        });
    }

    render() {
        this.icon = this.props.selectedIcon;
        this.build();
        return (
            <form
                action="./"
                method="POST"
                id="stripe-form"
                className="new-form billing-form no-ui-icon"
            >
                <section className="main-billing">
                    <div>
                        {this.account_price}
                        <ul>
                            <li>
                                {this.plan_selection}
                                <ol className="payment-information">
                                    <li>
                                        <h2 className="form-header">
                                            {gettext("Payment Information")}
                                        </h2>
                                    </li>
                                    <li>
                                        <input
                                            name="card_name"
                                            type="text"
                                            id="card_name"
                                            value={
                                                this.fields.card_name.inputValue
                                            }
                                            className={
                                                this.fields.card_name.className
                                            }
                                            placeholder={gettext(
                                                "Name on card"
                                            )}
                                            onFocus={this.onInteraction.bind(
                                                this
                                            )}
                                            onKeyUp={this.onInteraction.bind(
                                                this
                                            )}
                                            onBlur={this.onInteraction.bind(
                                                this
                                            )}
                                            disabled={this.fields.disabled}
                                            required
                                        />
                                        <label
                                            className={
                                                this.fields.card_name
                                                    .labelClassName
                                            }
                                            htmlFor="card_name"
                                        >
                                            {this.fields.card_name.labelText}
                                        </label>
                                    </li>
                                    <li>
                                        <input
                                            type="text"
                                            id="card_number"
                                            value={
                                                this.fields.card_number
                                                    .inputValue
                                            }
                                            className={
                                                this.fields.card_number
                                                    .className
                                            }
                                            placeholder={gettext(
                                                "Credit Card Number"
                                            )}
                                            onFocus={this.onInteraction.bind(
                                                this
                                            )}
                                            onKeyUp={this.onInteraction.bind(
                                                this
                                            )}
                                            onBlur={this.onInteraction.bind(
                                                this
                                            )}
                                            disabled={this.fields.disabled}
                                            required
                                        />
                                        <label
                                            className={
                                                this.fields.card_number
                                                    .labelClassName
                                            }
                                            htmlFor="card_number"
                                        >
                                            {this.fields.card_number.labelText}
                                        </label>
                                        <span id="card-type" />
                                    </li>
                                    <div>
                                        <li className="half">
                                            <input
                                                name="card_expiration"
                                                type="text"
                                                id="card_expiration"
                                                value={
                                                    this.fields.card_expiration
                                                        .inputValue
                                                }
                                                className={
                                                    this.fields.card_expiration
                                                        .className
                                                }
                                                onFocus={this.onInteraction.bind(
                                                    this
                                                )}
                                                onKeyUp={this.onInteraction.bind(
                                                    this
                                                )}
                                                onBlur={this.onInteraction.bind(
                                                    this
                                                )}
                                                placeholder="MM/YY"
                                                maxLength="5"
                                                disabled={this.fields.disabled}
                                                required
                                            />

                                            <label
                                                className={
                                                    this.fields.card_expiration
                                                        .labelClassName
                                                }
                                                htmlFor="card_expiration"
                                            >
                                                {
                                                    this.fields.card_expiration
                                                        .labelText
                                                }
                                            </label>
                                        </li>
                                        <li className="half">
                                            <input
                                                type="text"
                                                id="card_cvc"
                                                value={
                                                    this.fields.card_cvc
                                                        .inputValue
                                                }
                                                placeholder="CVC"
                                                className={
                                                    this.fields.card_cvc
                                                        .className
                                                }
                                                onFocus={this.onInteraction.bind(
                                                    this
                                                )}
                                                onKeyUp={this.onInteraction.bind(
                                                    this
                                                )}
                                                onBlur={this.onInteraction.bind(
                                                    this
                                                )}
                                                maxLength="4"
                                                disabled={this.fields.disabled}
                                                required
                                            />
                                            <label
                                                className={
                                                    this.fields.card_cvc
                                                        .labelClassName
                                                }
                                            >
                                                {this.fields.card_cvc.labelText}
                                            </label>
                                            <span className="help-container within-input">
                                                <a
                                                    href="#help-whats-a-cvc-anyways"
                                                    className="help-tip ui_help"
                                                    tabIndex="20"
                                                >
                                                    <span className="visuallyhidden">
                                                        Get more help
                                                    </span>
                                                </a>
                                                <div
                                                    id="help-whats-a-cvc-anyways"
                                                    className="help-box"
                                                >
                                                    <h2 className="help-headline">
                                                        {gettext(
                                                            "Find your credit card verification code"
                                                        )}
                                                    </h2>
                                                    <p className="help-body-copy">
                                                        {gettext(
                                                            "The card security code is typically the last three or four digits printed, not embossed like the card number, on the signature strip on the back of the card. American Express codes are generally found on the front side."
                                                        )}
                                                    </p>
                                                </div>
                                            </span>
                                        </li>
                                    </div>
                                    {this.save_payment}
                                    {this.toggle_optional_billing}
                                </ol>
                            </li>
                        </ul>
                    </div>
                </section>

                {this.optional_billing}

                <section className="end-billing">
                    <div>
                        <ul>
                            {this.sub_total_copy}
                            {this.submit_btn}
                            {this.upgrade_disclaimer}
                        </ul>
                        <div
                            className={
                                this.fields.general
                                    .labelClassName
                            }
                        >
                            {this.fields.general.labelText}
                        </div>
                    </div>
                </section>
            </form>
        );
    }
}

export default Billing_Form;
